import React from 'react';
// import { Button } from 'antd';
import { Button, message, Input, Select, Cascader } from 'antd';
import styles from './index.less';
import { CITY_MAP } from './utils';
// import { getDictionary } from '@/services/common';
import { transformTreeData } from '@/utils';
const AMap = (window as Window & typeof globalThis & { AMap: any }).AMap;

type ad = {
  address: string; //详细地址
  doorplate?: string; //门牌号
  pointData: {
    location: {
      lat: number;
      lng: number;
    };
    pname: string; //省
    cityname: string; //市
    name: string;
  };
};

type Value = {
  doorplate?: string;
  address: string;
  pointData: any;
};

interface MapMaskProps {
  onChange: (point: Value) => void;
  // onSelect: (point) => void;
  onCancel: () => void;
  value?: Value;
  defaultValue?: Value;
}
class MapMask extends React.Component<MapMaskProps, any> {
  // static getDerivedStateFromProps(nextProps: MapMaskProps, prevState: any) {
  //   if ('value' in nextProps) {
  //     return {
  //       ...nextProps.value,
  //       selectCity: nextProps.value ? nextProps.value.pointData?.cityname : prevState.selectCity,
  //       searchValue: nextProps.value ? nextProps.value.pointData?.name : prevState.searchValue,
  //     }
  //   }
  //   return null
  // }

  constructor(props: MapMaskProps) {
    super(props);
    // console.log(props)
    this.state = {
      pointData: props.defaultValue ? props.defaultValue.pointData : {},
      selectCity: props.defaultValue
        ? props.defaultValue.pointData
          ? [props.defaultValue.pointData.pname, props.defaultValue.pointData.cityname]
          : ['浙江省', '杭州市']
        : ['浙江省', '杭州市'],
      searchValue: props.defaultValue ? props.defaultValue.pointData?.name : undefined,
      doorplate: props.defaultValue ? props.defaultValue.doorplate : undefined,
      address: props.defaultValue ? props.defaultValue.address : undefined,
      dictionary: [],
    };
  }
  map: any;
  AMap: any;
  marker: any;
  placeSearch: any;
  auto: any;

  geocoder: any;
  selectedPoint: any;

  createDefaultMask = () => {
    const { defaultValue = { pointData: {} } } = this.props;
    const { pointData } = defaultValue;
    //构建自定义信息窗体
    function createInfoWindow(title: any, content: any) {
      var info = document.createElement('div');
      info.className = 'gd-custom-info gd-input-card gd-content-window-card';

      //可以通过下面的方式修改自定义窗体的宽高
      //info.style.width = "400px";
      // 定义顶部标题
      var top = document.createElement('div');
      var titleD = document.createElement('div');
      var closeX = document.createElement('img');
      top.className = 'gd-info-top';
      titleD.innerHTML = title;
      closeX.src = 'https://webapi.amap.com/images/close2.gif';
      closeX.onclick = closeInfoWindow;

      top.appendChild(titleD);
      top.appendChild(closeX);
      info.appendChild(top);

      // 定义中部内容
      var middle = document.createElement('div');
      middle.className = 'gd-info-middle';
      middle.style.backgroundColor = 'white';
      middle.innerHTML = content;
      info.appendChild(middle);

      // 定义底部内容
      var bottom = document.createElement('div');
      bottom.className = 'gd-info-bottom';
      bottom.style.position = 'relative';
      bottom.style.top = '0px';
      bottom.style.margin = '0 auto';
      var sharp = document.createElement('img');
      sharp.src = 'https://webapi.amap.com/images/sharp.png';
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    }

    //关闭信息窗体
    const closeInfoWindow = () => {
      this.map.clearInfoWindow();
    };
    const content: any[] = [];
    content.push(
      `地址：${pointData.district ? `${pointData.district}${pointData.address || ''}` : `${pointData.pname || ''}${pointData.cityname || ''}${pointData.adname || ''}${pointData.address || ''}`}`,
    );
    // content.push(`电话：${pointData.tel || '-'}`);
    // content.push("<a href='https://ditu.amap.com/detail/B000A8URXB?citycode=110105'>详细信息</a>");
    var infoWindow = new this.AMap.InfoWindow({
      isCustom: true, //使用自定义窗体
      content: createInfoWindow(pointData.name, content.join('<br>')), //传入 dom 对象，或者 html 字符串
      offset: new this.AMap.Pixel(16, -50),
    });
    //添加marker标记
    const addMarker = () => {
      this.map.clearMap();
      // 构造点标记
      const marker = new this.AMap.Marker({
        map: this.map,
        // icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [pointData?.location?.lng, pointData?.location?.lat],
      });
      //鼠标点击marker弹出自定义的信息窗体
      this.AMap.event.addListener(marker, 'click', () => {
        infoWindow.open(this.map, marker.getPosition());
      });
      this.map.add(marker);
    };
    addMarker();
  };

  async setDictionary() {
    // const response = await getDictionary();
    // this.setState({
    //   dictionary: response.data
    // })
  }
  initAmap() {
    this.map = new this.AMap.Map('container', {
      resizeEnable: true,
      level: 10,
      city: this.state.selectCity[1],
      center: this.props.defaultValue?.pointData
        ? [
            this.props.defaultValue?.pointData?.location?.lng,
            this.props.defaultValue?.pointData?.location?.lat,
          ]
        : [120.2126, 30.290851],
    });
    this.map.on('click', (e) => {
      console.log(e, '点击的定位');
      if (this.marker) {
        this.map.remove([this.marker]);
      }
      const startIcon = new this.AMap.Icon({
        // 图标尺寸
        size: new this.AMap.Size(51, 70),
        // 图标的取图地址
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
        // 图标所用图片大小
        imageSize: new this.AMap.Size(25, 35),
        // 图标取图偏移量
        // imageOffset: new AMap.Pixel(-9, -3)
      });
      this.marker = new this.AMap.Marker({
        icon: startIcon,
        position: [e.lnglat.lng, e.lnglat.lat],
        // offset: new AMap.Pixel(-10, -10)
      });

      this.AMap.plugin('AMap.Geocoder', () => {
        // 引入 Geocoder 逆向地理编码插件，把经纬度转为地址
        const geocoder = new this.AMap.Geocoder({
          radius: 1000, // 以给定坐标为中心点，单位：米。取值范围：0-3000。默认值：1000
          extensions: 'base', // 返回信息的详略。默认值：base，返回基本地址信息；取值为：all，返回地址信息及附近poi、道路、道路交叉口等信息
        });
        const lnglat = [e.lnglat.getLng(), e.lnglat.getLat()];
        geocoder.getAddress(lnglat, (status, result) => {
          // 传入经纬度，根据给定坐标进行解析，把经纬度转为地址
          console.log(status, result, 'status, result');
          if (status === 'complete' && result.info === 'OK') {
            console.log(result.regeocode, 'result.regeocode');
            const regeocode = result.regeocode || {};
            const addressComponent = regeocode.addressComponent || {};
            const pointData = {
              citycode: addressComponent.citycode,
              pname: addressComponent.province,
              adname: addressComponent.district,
              cityname: addressComponent.city || addressComponent.province, // 直辖市取省的值
              name: regeocode.formattedAddress,
              location: {
                lng: lnglat[0],
                lat: lnglat[1],
              },
              address: regeocode.formattedAddress,
            };
            this.setState({
              pointData,
              address: pointData.address,
            });
          }
        });
      });

      this.map.add([this.marker]);
    });
    this.AMap.service(['AMap.PlaceSearch'], () => {
      //构造地点查询类
      this.placeSearch = new this.AMap.PlaceSearch({
        pageSize: 5, // 单页显示结果条数
        pageIndex: 1, // 页码
        citylimit: true, //是否强制限制在设置的城市内搜索
        extensions: 'all',
        city: this.state.selectCity[1],
        map: this.map, // 展现结果的地图实例
        autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
      });
      //关键字查询

      this.placeSearch.on('markerClick', (data: any) => {
        console.log(data.data, '选中了');
        if (this.marker) {
          this.map.remove([this.marker]);
        }
        this.selectedPoint = data;
        this.setState({
          pointData: data.data,
          address: data.data.district
            ? `${data.data.district}${data.data.address || ''}${data.data.name || ''}`
            : data.data.name
              ? `${data.data.pname || ''}${data.data.cityname || ''}${data.data.adname || ''}${data.data.address || ''}${data.data.name || ''}`
              : '',
        });
      });
    });
    //输入提示
    this.auto = new this.AMap.Autocomplete({
      input: 'tipInput',
      city: this.state.selectCity[1],
      datatype: 'poi',
      citylimit: true,
    });
    console.log(this.auto, 'this.auto');
    this.auto.on('select', (data: any) => {
      // console.log(JSON.stringify(data))
      // console.log(data);
      // this.props.onSelect(data);
      this.selectedPoint = { data: data.poi };
      this.placeSearch.search(data.poi.name);
      this.setState({ searchValue: data.poi.name });
    });
  }
  componentDidMount() {
    this.setDictionary();
    this.AMap = (window as Window & typeof globalThis & { AMap: any }).AMap;
    setTimeout(() => {
      this.initAmap();
    }, 500);
    // console.log('--->', this.state, this.props)

    // this.placeSearch.on('markerClick', (data) => {
    //   // console.log(data, '选中了')
    //   this.selectedPoint = data;
    // })

    // this.geocoder = new AMap.Geocoder();
    // let lnglatXY = new AMap.LngLat(120.2126,30.290851);
    // this.geocoder.getAddress(lnglatXY, (status, result) => {
    //   console.log(status, result)
    // })

    setTimeout(() => {
      this.placeSearch.setCity(this.state.selectCity[1]);
      this.auto.setCity(this.state.selectCity[1]);
      // this.map.setCity(this.state.selectCity[1])
      if (this.props.defaultValue?.pointData) {
        this.map.setZoom(16);
        this.createDefaultMask();
      }
    }, 800);
  }

  save = () => {
    const { pointData, doorplate } = this.state;
    // console.log(pointData)
    if (!pointData.citycode) {
      message.error('请使用鼠标点击地图选择地点');
      return;
    }
    const o: Value = {
      doorplate,
      pointData,
      address: this.marker
        ? pointData.address
        : pointData.district
          ? `${pointData.district}${pointData.address || ''}${pointData.name || ''}`
          : pointData.name
            ? `${pointData.pname || ''}${pointData.cityname || ''}${pointData.adname || ''}${pointData.address || ''}${pointData.name || ''}`
            : '',
    };
    this.props.onChange(o);
  };
  cancel = () => {};
  componentWillUnmount() {
    this.map?.destroy?.();
  }
  render() {
    const { selectCity, searchValue, doorplate, address, dictionary } = this.state;
    return (
      <div className={styles.cc}>
        <div className={styles.search}>
          <Cascader
            onChange={(selectCity) => {
              // console.log(selectCity)
              this.setState({
                selectCity,
                searchValue: undefined,
                doorplate: undefined,
                address: undefined,
                pointData: {},
              });
              this.placeSearch.setCity(selectCity[1]);
              this.auto.setCity(selectCity[1]);
              this.map.setCity(selectCity[1]);
            }}
            value={selectCity}
            style={{ width: 210, marginRight: 12 }}
            options={CITY_MAP}
          />
          <Input
            placeholder="输入地址搜索"
            value={searchValue}
            onChange={(evt) => this.setState({ searchValue: evt.target.value })}
            id="tipInput"
            type="text"
            autoComplete="off"
          />
        </div>
        <div className={styles.container}>
          <div id="container" className={styles.content}></div>
        </div>
        <div className={styles.address}>
          <div>
            <span>地点：</span>
            <Input disabled value={address} />
          </div>
          <div>
            <span>备注：</span>
            <Input
              placeholder='请输入具体地点，如"电梯扶手旁“或具体门牌号'
              value={doorplate}
              onChange={(evt) => {
                this.setState({ doorplate: evt.target.value });
              }}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <Button onClick={this.save} type="primary">
            保存
          </Button>
          <Button onClick={this.props.onCancel} style={{ marginLeft: 12 }}>
            取消
          </Button>
        </div>
      </div>
    );
  }
}

export default MapMask;
